/* global ajaxUrl */

jQuery(document).ready(function ($) {
  if($('.elementor-widget-eet-system-status').length === 0) {
    return;
  }

  // system status
  $.ajax({
    type: "GET",
    dataType: "json",
    url: ajaxUrl,
    data: {
      action: "eetGetSystemStatus",
    },
    success: (data) => {

      $('.system-intro-text').html(data.introText);

      const serverIconEl = $('.system-status__status-box.server-status .system-status__status-icon');
      serverIconEl.removeClass('up').removeClass('slow').removeClass('down');
      serverIconEl.addClass(data.communicationServerStatus);

      const serverTextWrapperEl =  $('.system-status__status-box.server-status .system-status__status-content--text');
      serverTextWrapperEl.removeClass('up').removeClass('slow').removeClass('down');
      serverTextWrapperEl.addClass(data.communicationServerStatus);

      const serverTextEl =  $('.system-status__status-box.solmate-status .communication-server-text');
      serverTextEl.html(data.communicationServerText);

      const serverStatusIconEl = $('.system-status__status-box.server-status .status-icon');
      serverStatusIconEl[0].type = data.communicationServerStatus;

      const solmateIconEl = $('.system-status__status-box.solmate-status .solmate-status__status-icon');
      solmateIconEl.removeClass('up').removeClass('slow').removeClass('down');
      solmateIconEl.addClass(data.solmateStatus);

      const solmateTextWrapperEl =  $('.system-status__status-box.solmate-status .system-status__status-content--text');
      solmateTextWrapperEl.removeClass('up').removeClass('slow').removeClass('down');
      solmateTextWrapperEl.addClass(data.solmateStatus);

      const solmateTextEl =  $('.system-status__status-box.solmate-status .solmate-status-text');
      solmateTextEl.html(data.solmateStatusText);

      const solmateStatusIconEl = $('.system-status__status-box.solmate-status .status-icon');
      solmateStatusIconEl[0].type = data.solmateStatus;

      $('.known-issues-text').html(data.knownIssuesText);

    },
    error: (error) => {
      console.log("status works not");
      console.log(error);
    },
  });

  // release notes
  $.ajax({
    type: "GET",
    dataType: "json",
    url: ajaxUrl,
    data: {
      action: "eetGetReleaseNotes",
    },
    success: (data) => {

      $('.notes-intro-text').html(data.introText);
      $('.notes-latest-releases').html(data.latestReleases);
      $('.notes-previous-releases').html(data.previousReleases);

    },
    error: (error) => {
      console.log("notes work not");
      console.log(error);
    },
  });
});